import { render, staticRenderFns } from "./SetTempTask.vue?vue&type=template&id=9547dd7c"
import script from "./SetTempTask.vue?vue&type=script&lang=js"
export * from "./SetTempTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports